var uiKit = {
  datepicker: {
    sunday: '日曜日',
    monday: '月曜日',
    tuesday: '火曜日',
    wednesday: '水曜日',
    thursday: '木曜日',
    friday: '金曜日',
    saturday: '土曜日',
    sunday_short: '(日)',
    monday_short: '(月)',
    tuesday_short: '(火)',
    wednesday_short: '(水)',
    thursday_short: '(木)',
    friday_short: '(金)',
    saturday_short: '(土)',
    january: '1月',
    february: '2月',
    march: '3月',
    april: '4月',
    may: '5月',
    june: '6月',
    july: '7月',
    august: '8月',
    september: '9月',
    october: '10月',
    november: '11月',
    december: '12月',
    pick_year: '年を選択',
    pick_month: '月を選択',
    pick_date: '日を選択'
  }
};

export default {
  myaccount: {
    welcomeBar: {
      hi: 'こんにちは',
      lastLogin: '前回ログイン',
      fullDate: '{{year}}-{{month}}-{{day}} {{hour}}',
      months: {
        '01': '01',
        '02': '02',
        '03': '03',
        '04': '04',
        '05': '05',
        '06': '06',
        '07': '07',
        '08': '08',
        '09': '09',
        10: '10',
        11: '11',
        12: '12'
      }
    },
    accountInfo: {
      id: 'ID'
    },
    navigationMenu: {
      title: {
        myBets: 'マイベット',
        accountHistory: 'アカウント履歴',
        withdraw: '出金',
        reversalWithdraw: 'キャンセル可能な出金',
        myRewards: 'マイリワード',
        myAccount: 'マイアカウント',
        depositLimit: '入金限度',
        deposit: '入金',
        gamblingControls: 'ギャンブルの管理',
        saferGambling: 'より安全なギャンブル',
        pokerBalanceTransfer: '資金を移行'
      }
    },
    profitAndLoss: {
      title: '利益と損失',
      description: {
        up: '今月の利益は{{value}}です',
        down: '今月の損失は{{value}}です'
      }
    },
    myAccountTitles: {
      title: {
        accountHistory: 'アカウント履歴',
        personalDetails: '個人情報',
        loginSecuritySettings: 'ログイン & セキュリティ設定',
        siteSettings: 'サイト設定'
      },
      listItems: {
        statementsView: '取引履歴',
        summaries: '一覧',
        contactName: '連絡先氏名',
        contactDetails: '連絡先詳細',
        marketingPreferences: 'マーケティング設定',
        autoLogin: '自動ログイン',
        twoFactorAuth: '二要素認証',
        password: 'パスワード',
        oddsFormat: 'オッズ形式'
      }
    },

    saferGambling: {
      tilesConfig: {
        header: {
          text: 'ギャンブルは常に楽しめるものでなければなりません。そのため、ギャンブルの資金をコントロールできるツールをご用意しました。'
        },

        footer: {
          text: '当社が行っているプレイヤーへのサポートをご覧ください。',
          link: 'より安全なギャンブル'
        },
        selfAssessment: {
          title: '自己診断',
          description: '自己診断ツールを活用して、ギャンブルの習慣を見直しましょう。2分で診断出来ます！'
        },
        survey: {
          title: '安全なプレイに関するアンケート',
          description: '安全にプレイされていますか?アンケートにお答えいただきご確認ください。'
        },
        depositLimits: {
          title: '入金制限',
          description: 'アカウントでの入金額を日ごと、週ごと、また月ごとなどプレイヤーが指定する期間で制限できます。'
        },

        gamingTimeReminder: {
          title: 'ゲームタイマー',
          description: '当サイトのゲーム製品でご利用可能となり、ゲームのプレイ時間をお知らせするタイマーを設定できます。'
        },

        timeOut: {
          title: 'タイムアウト',
          descriptionUk: 'ギャンブルを一時中断したい場合、プレイヤーのアカウントに最大42日のタイムアウトを設定することができます。',
          descriptionNonUk: 'ショートタイムアウトを取る。最長6ヶ月間ギャンブルを一時中断することができます。'
        },

        accountClosure: {
          title: 'アカウント閉鎖',
          description: 'アカウントの閉鎖をご希望される場合はこちらから閉鎖が可能です。'
        },

        selfExclusion: {
          title: '完全自己除外',
          description: 'アカウントを6か月から5年間閉鎖します。'
        },
        profitAndLoss: {
          title: '利益と損失',
          description: {
            up: '今月の利益は{{value}}です',
            down: '今月の損失は{{value}}です'
          }
        }
      },

      views: {
        depositLimits: {
          day: '日額制限',
          week: '週額制限',
          month: '月額制限',
          viewHeader: {
            title: '入金制限を設定する',
            content: 'アカウントでの入金額を日ごと、週ごと、また月ごとなどプレイヤーが指定する期間で制限できます。<br>' + '<a href="https://williamhill-jp.custhelp.com/app/answers/detail/a_id/10220#1" rel="noopener noreferrer" target="_blank">設定方法</a>'
          },
          limits: {
            daily: '日額制限',
            weekly: '週額制限',
            monthly: '月額制限'
          },
          periods: {
            day: '日額制限',
            week: '週額制限',
            month: '月額制限'
          },
          buttonText: '入金制限を保存する',
          chooseLimit: '制限を選択する',
          valueNotSet: '制限',
          noLimit: '制限なし',
          noLimitSet: '制限なし',
          remainingDeposit: {
            day: '日額制限で入金可能な金額は残り{{amount}}です',
            week: '週額制限で入金可能な金額は残り{{amount}}です',
            month: '月額制限で入金可能な金額は残り{{amount}}です'
          },
          emptyRemainingDeposit: '入金制限が設定されていません',
          successMessage: '入金制限が変更されました',
          confirmationButton: '入金制限{{amount}}への変更を確認する',
          confirmationButtonNoLimit: '入金制限制限なしへの変更を確認する',
          confirmationMessage: {
            day: '日額制限の{{amount}}は{{date}}日{{time}}（英国時間) 時に再度確認が必要です。<br><br>' + 'キャンセルするには<a href="#">ここをクリックしてください</a>',
            week: '週額制限の{{amount}}は{{date}}日{{time}}（英国時間) 時に再度確認が必要です。<br><br>' + 'キャンセルするには<a href="#">ここをクリックしてください</a>',
            month: '月額制限の{{amount}}は{{date}}日{{time}}（英国時間) 時に再度確認が必要です。<br><br>' + 'キャンセルするには<a href="#">ここをクリックしてください</a>'
          },
          confirmationMessageNoLimit: {
            day: '日額制限の制限なしは{{date}}日{{time}}（英国時間) 時に再度確認が必要です。<br><br>' + 'キャンセルするには<a href="#">ここをクリックしてください</a>',
            week: '週額制限の制限なしは{{date}}日{{time}}（英国時間) 時に再度確認が必要です。<br><br>' + 'キャンセルするには<a href="#">ここをクリックしてください</a>',
            month: '月額制限の制限なしは{{date}}日{{time}}（英国時間) 時に再度確認が必要です。<br><br>' + 'キャンセルするには<a href="#">ここをクリックしてください</a>'
          },
          confirmationSuccessful: '入金制限が変更されました',
          increaseWarning: '入金制限を増額されたい場合は24時間後再度確認が必要となります。',
          footerContent: 'ご希望の限度額が見つからない場合は<br/>' + '<a href="https://williamhill-jp.custhelp.com/app/ask" rel="noopener noreferrer" target="_blank">カスタマーサポートまでご連絡ください<。/a>',
          cancellationModalContent: '入金制限の増額をキャンセルされますか?'
        },

        gamingTimeReminder: {
          accordionText: 'ゲームセッションタイマー',
          currentReminder: '現在のタイマー：',
          reminders: {
            placeholder: 'タイマーを選択',
            noReminder: 'タイマーなし',
            minutes: '{{time}} 分',
            hour: '{{time}} 時間',
            hours: '{{time}} 時間'
          },
          submitButton: 'タイマーを保存する',
          warningMessage: '新しいタイマーは現在のタイマーが終了次第、またゲーム終了後に開始されます。',
          successMessage: 'ゲームのタイマーが変更されました',
          viewHeader: {
            title: 'ゲームのタイマーを設定する',
            content: '<p>自動タイマーを設定するとどのくらいの時間ゲームをプレイされているかお知らせします。</p><a href="https://williamhill-lang.custhelp.com/app/answers/detail/a_id/10220/#session_time_reminders" rel="noopener noreferrer" target="_blank">設定方法</a></br></br>' + '<p>こちらはゲーム製品でのみ利用できます。 ゲーム製品には、スポーツ、ポーカー、バーチャル、またはフリープレイのトーナメントは含まれません。 Evolution Gaming製品にてリマインダーを設定するには、ゲームを起動し、「設定」、「ゲームセッション設定」の順に選択します。</p>'
          },
          valueNotSet: '設定なし'
        },

        timeOut: {
          viewHeader: {
            title: 'タイマーを設定する',
            contentUk: 'ギャンブルを一時中断したい場合、最大42日までお客様のアカウントにタイムアウトを適用することが可能です。</br><a href="https://williamhill-jp.custhelp.com/app/answers/detail/a_id/10220#3" rel="noopener noreferrer" target="_blank">設定方法</a>',
            contentNonUk: 'ギャンブルを一時中断したい場合、最長6か月のタイムアウトを適用することが可能です。</br><a href="https://williamhill-jp.custhelp.com/app/answers/detail/a_id/10220#3" rel="noopener noreferrer" target="_blank">設定方法</a>'
          },
          formLabel: 'タイムアウトの希望期間',
          values: {
            placeholder: 'タイムアウト期間を選択してください',
            day: '1日',
            days: '{{amount}} 日',
            valueNotSet: 'タイムアウトなし'
          },
          formHeader: 'アカウント閉鎖する',
          passwordPlaceholder: 'パスワードを入力',
          submitButton: 'タイムアウトを保存する',
          viewFooter: '30日間以上のタイムアウトを希望される場合は<a href="https://williamhill-jp.custhelp.com/app/ask" rel="noopener noreferrer" target="_blank">カスタマーサポートまでご連絡ください</a>',
          resultPage: {
            title: 'お客様のアカウントは現在タイムアウト中です',
            information: '{{period}}日間アカウントにアクセスできません。',
            helpSectionMainText: '長期間ギャンブルを中断されたい場合はご利用のデバイスからベッティングのアプリを削除されることをお勧めします。詳細は責任あるギャンブルのページをご覧ください。'
          }
        },

        accountClosure: {
          header: 'はい、アカウントを閉鎖します。',
          listTitle: '注意事項：',
          firstListElement: '責任あるギャンブルを理由にアカウントの一時中断、または閉鎖をお考えの場合はアカウントのタイムアウト（最大6週間）、または<a href="https://williamhill-jp.custhelp.com/app/answers/detail/a_id/10220#3" rel="noopener noreferrer" target="_blank">自己除外</a>（最大5年間）を検討してください。',
          secondListElement: 'アカウントにある残金の出金申請を行ってください。',
          thirdListElement: 'お客様のデータは少なくとも5年間は保管されます。詳細は<a href="https://williamhill-jp.custhelp.com/app/answers/detail/a_id/10220#4" rel="noopener noreferrer" target="_blank">プライバシーポリシー</a>をご確認ください。',
          formHeader: 'アカウントを閉鎖する',
          closureReasonPlaceholder: '理由を選択する',
          passwordPlaceholder: 'パスワードを入力',
          submitButton: 'アカウントを閉鎖する',
          reasons: {
            CLOSURE_REASON_OFFERS: 'オファーに満足していない',
            CLOSURE_REASON_PRODUCTS: '製品に満足していない',
            CLOSURE_REASON_SERVICE: 'サービスに満足していない',
            CLOSURE_REASON_TIME: 'アカウントを使用する空き時間がない',
            CLOSURE_REASON_CHANGES: '最近行われた変更が好きではない',
            CLOSURE_REASON_PROVIDER: '他のプロバイダーを使用している',
            CLOSURE_REASON_SECRET: '言いたくない'
          }
        },

        accountClosed: {
          title: 'お客様のアカウントが閉鎖されました。',
          text: '出金を申請するには<br>' + '<a href="https://williamhill-jp.custhelp.com/app/ask" rel="noopener noreferrer" target="_blank">カスタマーサポートまでご連絡ください</a><br><br>' + 'お客様はアカウント再取得ページから、いつでもアカウントを再開することが可能です。',
          helpSectionMainText: '責任あるギャンブルを理由にアカウントの一時中断、または閉鎖をお考えの場合はアカウントのタイムアウト（最大6週間）、または自己除外（最大5年間）を検討してください。<br><br>' + '詳細は責任あるギャンブルのページをご覧ください。'
        },

        gamblingHelpSection: {
          bottomSectionTitle: '詳細',
          bottomSectionText: 'ギャンブルを管理する方法に関してアドバイスを行う独立した支援団体は無料でご利用頂けます。',
          mainButtonText: '安全なギャンブルのページに移動する',
          bottomSectionFirstButton: 'GamCare',
          bottomSectionSecondButton: 'ギャンブラーズアノニマス',
          bottomSectionThirdButton: 'ギャンブリングセラピー',
          gamstopHeader: 'GAMSTOP',
          gamstopContent: 'お使いのデバイスからWilliam Hill、またはその他ギャンブルプロバイダーのモバイルアプリをアンインストールされることを強くお勧めします。なお、英国でGAMSTOPに登録している他のギャンブルサイトから自己除外を設定することができます。',
          gamstopButton: 'GAMSTOPに移動する'
        },

        selfExclusionSelection: {
          viewHeader: {
            title: '自己除外を設定する',
            content: '万が一、問題があると思われ、ギャンブルを完全に中止されたい場合は、GAMSTOPのご利用をお勧めします。<br /><br />GAMSTOPは、英国で認可を受けたギャンブルサイトおよびアプリから、お客様を希望される期間除外することができ、ギャンブルをご自身で管理いただけます。<br /><br />なお、自己除外は最小6か月から最大5年間で設定することが可能です。'
          },
          gamstopButton: 'GAMSTOPに移動',
          selfExcludeFromWH: 'ウィリアムヒルから自己除外する'
        },

        selfExclusion: {
          viewHeader: {
            title: '自己除外を設定する',
            content: '最短6か月から5年間、当社製品へのアクセスを防ぐために、お客様を当社サービスから除外することが出来ます。<br>' + '<a href="https://williamhill-jp.custhelp.com/app/answers/detail/a_id/10220#4" rel="noopener noreferrer" target="_blank">設定方法</a><br/><br/>' + '<p>自己除外は設定された期間が終了するまでどの状況下においても取り消しを行うことはできません。</p>'
          },
          upperSectionLabel: '自己除外を設定しますか?',
          termsMessage: 'William Hillで自己除外を設定することで、お客様は{{termsMessageLink}}に同意することになります。<br /><br />' + '自己除外を設定された期間中、お客様はアカウントにアクセスできず、期間終了までアカウントを再開することはできません。',
          termsMessageLink: '利用規約', // please notice this is a part of the previous key
          formLabel: 'タイムアウトの希望期間',
          upperButton: 'はい、自己除外を設定します。',
          period: {
            months: '{{amount}} か月',
            year: '1 年',
            years: '{{amount}} 年',
            valueNotSet: '自己除外期間なし',
            indefinite: '無期限（最低1年)'
          },
          exclusionPeriodPlaceholder: '自己除外期間',
          passwordPlaceholder: 'パスワード入力',
          submitButton: 'パスワード入力',
          brandsNote: {
            text: 'William Hillで自己除外が設定されている場合であっても、888ブランドでお持ちのアカウントにおいて<span style="font-weight: bold;">自己除外が自動的に適用されることはなく</span>、直接888ブランドから自己除外する必要がありますのでご注意ください。',
            link888: '888.comから自己除外する',
            link777: '777.comから自己除外する'
          }
        },

        termsAndConditions: {
          text: 'この文書はインターネットによるベットおよび電話によるテレベッティングからお客様を除外することに関し、お客様とWHG（International）Limitedの間で行われる自発的な取り決めを確認するものです。<br><br><br>' + 'お客様は自身のアカウント閉鎖を要求し、お客様からの要求をWHG（International）Limitedが確認後、お客様自身が選択した期間中、WHG（International）Limitedでのインターネットによるベット、ゲームプレイ、および電話によるテレベッティングにおけるあらゆる活動を拒否することを要求します。なおこの自己除外期間が終了するまで、プレイヤーはこれを修正、取り消す、また撤回することはできません。<br><br><br>' + 'ご注意：インターネットでのプレイからの除外はアカウント番号とメールアドレスが参照され、テレベッティングからの除外はアカウント番号が参照されます。また、お客様のアカウントに関連するクレジットカード番号またデビットカード番号の使用を併せて除外するため当社は合理的な措置を講じます。William Hillに接続されるすべてのアプリまたはダウンロードをご自身のデバイスから削除/アンインストールされることを強くお勧めします。<br><br><br>' + '自己除外の期間終了時、またはその後プレイヤーはいつでもこの自己除外に関しカスタマーサポートと確認を行い、新たに期間を更新するか、ギャンブルを再開するか選択できます。プレイヤーが除外の延長を希望しない場合、さらに1日の除外期間が適用され、その後アカウントへのアクセスと使用が許可されます。',
          button: '利用規約を確認しました'
        },

        selfExcluded: {
          title: 'お客様のアカウントは自己除外されました。',
          subtitle: {
            months: 'お客様はアカウントヘ{{amount}}か月間はアクセスすることが出来なくなります。',
            year: 'お客様はアカウントヘ{{amount}}年間はアクセスすることが出来なくなります。',
            years: 'お客様はアカウントヘ{{amount}}年間はアクセスすることが出来なくなります。',
            indefinite: 'お客様のアカウントは無期限で自己除外され、最低1年間はアカウントにアクセスできなくなります。'
          },
          helpSectionMainText: 'ギャンブルから適切な休憩を取るために、他のギャンブルサイトやアプリをお使いのデバイスから削除されることをお勧めします。なお、お客様のアカウント残高は自動的に返金されます。詳細については安全なギャンブルのページからご覧ください。'
        },

        divider: {
          or: 'または'
        }
      },

      valueNotSet: '設定なし',
      incorrectPasswordErrorMessage: 'パスワードに誤りがあります',
      genericError: 'エラーが発生しました。しばらく経ってから再度お試しいただくか、カスタマーサポートまでご連絡ください。'
    },

    header: {
      error: {
        message: 'データを取得できませんでした',
        retry: '再試行'
      },
      title: {
        accountHistory: 'アカウント履歴',
        accountNetDeposit: '入金詳細',
        deposit: '入金',
        depositLimitsPage: '入金制限',
        landing: 'マイアカウント',
        loginSecurity: 'ログイン & セキュリティ',
        myAccount: 'マイアカウント',
        myBets: 'マイベット',
        personalDetails: '個人情報',
        siteSettings: 'サイト設定',
        summaryExport: '一覧エクスポート',
        saferGambling: 'より安全なギャンブル',
        gamingTimeReminderPage: 'ゲームタイマー',
        accountClosure: 'アカウント閉鎖',
        accountClosed: 'アカウント閉鎖',
        timeOutResult: 'タイムアウト',
        timeOut: 'タイムアウト',
        termsAndConditions: '完全自己除外',
        selfExclusionSelectionPage: '完全自己除外',
        selfExclusionPage: '完全自己除外',
        selfExcluded: '完全自己除外',
        bonusLanding: '残高情報',
        survey: '安全なプレイに関するアンケート',
        surveyResult: '安全なプレイに関するアンケート'
      }
    },
    balanceAndBonus: {
      cashBalance: 'キャッシュ残高',
      additionalBalance: { sportsbook: 'フリーベット', gaming: 'ゲーミングボーナス' },
      balanceInfoLink: '残高情報'
    },
    bonusLanding: {
      withdrawable: {
        title: '残高を出金',
        balances: {
          mainCashBalance: { mainText: 'キャッシュ残高', helperText: 'ポーカー以外でご利用頂けます' }, //@deprecated, use sportsbook key instead
          pokerCashBalance: { mainText: 'ポーカーキャッシュ残高', helperText: 'ポーカーのみでご利用頂けます' }, //@deprecated, use poker key instead
          sportsbook: { mainText: 'キャッシュ残高', helperText: 'ポーカー以外でご利用頂けます' },
          poker: { mainText: 'ポーカーキャッシュ残高', helperText: 'ポーカーのみでご利用頂けます' }
        }
      },
      bonus: {
        title: 'ボーナス残高',
        balances: {
          gaming: {
            mainText: 'ゲーミング',
            helperText: 'ゲーミングに使用できるボーナス資金',
            buyInBalance: {
              mainText: 'バイイン残高',
              helperText: 'ボーナスに必要となるキャッシュ残高'
            },
            bonusBalance: {
              mainText: 'ボーナス残高',
              helperText: 'ボーナス資金と保留中の払戻金'
            }
          },
          sportsbook: {
            mainText: 'スポーツフリーベット',
            helperText: 'スポーツベットに使用できる無料クレジット'
          },
          bingo: { mainText: 'ビンゴ', helperText: 'ビンゴに使用できるボーナス資金' },
          poker: { mainText: 'ポーカー', helperText: 'ポーカーに使用できるボーナス資金' }
        }
      },
      footerText: {
        gaming: '「プロモーション」より本日ご利用頂けるボーナスをご覧ください'
      },
      buttonText: { gaming: 'プロモーションを見る' }
    },
    transactions: {
      reference: '取引番号',
      aamsId: 'ID AAMS:',
      EW: 'イーチウェイ',
      eachWay: 'イーチウェイ 1-{{places}} 着順, {{price}} オッズ',
      stake: 'ステイク',
      refund: '返金',
      return: '払戻し',
      bonusStake: 'ボーナスステイク',
      stakeTotal: 'ステイク合計',
      numberOfLines: 'x {{value}} ベット',
      tab: {
        summary: '概要',
        history: '取引'
      },
      myBets: {
        open: 'オープン',
        settled: '確定済み'
      },
      price: {
        '@ SP': '@ SP',
        '@ Guaranteed Price': '@ オッズ保証 ({{price}})'
      },
      accountNetDeposit: {
        buttonLabel: '見る',
        buttonTitle: '入金詳細'
      },
      lotteryBet: {
        draw: '抽選',
        result: '結果'
      },
      totePoolBetting: 'トートプールベッ',
      bettingTerminal: 'ベッティングターミナル',
      type: {
        BET_ACCUMULATOR_10: 'アキュムレーター (10)',
        BET_ACCUMULATOR_11: 'アキュムレーター (11)',
        BET_ACCUMULATOR_12: 'アキュムレーター (12)',
        BET_ACCUMULATOR_13: 'アキュムレーター (13)',
        BET_ACCUMULATOR_14: 'アキュムレーター (14)',
        BET_ACCUMULATOR_15: 'アキュムレーター (15)',
        BET_ACCUMULATOR_16: 'アキュムレーター (16)',
        BET_ACCUMULATOR_17: 'アキュムレーター (17)',
        BET_ACCUMULATOR_18: 'アキュムレーター (18)',
        BET_ACCUMULATOR_19: 'アキュムレーター (19)',
        BET_ACCUMULATOR_20: 'アキュムレーター (20)',
        BET_ACCUMULATOR_21: 'アキュムレーター (21)',
        BET_ACCUMULATOR_22: 'アキュムレーター (22)',
        BET_ACCUMULATOR_23: 'アキュムレーター (23)',
        BET_ACCUMULATOR_24: 'アキュムレーター (24)',
        BET_ACCUMULATOR_25: 'アキュムレーター (25)',
        BET_ACCUMULATOR_4: 'フォーフォールド',
        BET_ACCUMULATOR_5: 'ファイブフォールド',
        BET_ACCUMULATOR_6: 'シックスフォールド',
        BET_ACCUMULATOR_7: 'セブンフォールド',
        BET_ACCUMULATOR_8: 'エイトフォールド',
        BET_ACCUMULATOR_9: 'ナインフォールド',
        BET_CANADIAN: 'カナディアン',
        BET_DDB: 'トート - デイリーダブル',
        BET_DOUBLE: 'ダブル',
        BET_DOUBLES: 'ダブル',
        BET_EIGHTFOLDS: 'エイトフォールド',
        BET_EXA: 'トート - 連勝単式',
        BET_FIVEFOLDS: 'ファイブフォールド',
        BET_FLG: 'フラッグ',
        BET_FOURFOLDS: 'フォーフォールド',
        BET_GOLIATH: 'ゴリアテ',
        BET_HEINZ: 'ハインツ',
        BET_LUCKY_15: 'ラッキー15',
        BET_LUCKY_31: 'ラッキー31',
        BET_LUCKY_63: 'ラッキー63',
        BET_MAN: '手動調整',
        BET_NINEFOLDS: 'ナインフォールド',
        BET_PATENT: 'Patent',
        BET_PK3: 'トート - ピック3',
        BET_PK4: 'トート - ピック4',
        BET_PK6: 'トート - ピック6',
        BET_PK9: 'トート - ピック9',
        BET_PLC: 'トート - プレイス',
        BET_QIN: 'トート - 馬連',
        BET_ROB: 'ラウンドロビン',
        BET_SEVENFOLDS: 'セブンフォールズ',
        BET_SHW: 'トート - 複勝',
        BET_SINGLE: 'シングル',
        BET_SIXFOLDS: 'シックスフォールド',
        BET_SPR: 'トート - 4連単',
        BET_SUPER_HEINZ: 'スーパーハインツ',
        BET_TENFOLDS: 'テンフォールズ',
        BET_TREBLE: 'トレブル',
        BET_TREBLES: 'トレブル',
        BET_TRI: 'トート - 3連単',
        BET_TRIXIE: 'トリクシー',
        BET_UEXA: 'トート - 連勝単式',
        BET_UJKP: 'トート - ジャックポット',
        BET_UKN: 'ベット',
        BET_UPLC: 'トート - プレイス',
        BET_UPLP: 'トート - プレイスポット',
        BET_UQDP: 'トート - クワドポット',
        BET_USC6: 'トート - スクープ6',
        BET_USC7: 'トート - スクープ7',
        BET_USW: 'トート - スウィンガー（ワイド）',
        BET_UTD: 'トート - ダブル',
        BET_UTRI: 'トート - 3連単',
        BET_UTT: 'トート - トレブル',
        BET_UWIN: 'トート - 単勝',
        BET_WIN: 'トート - 単勝',
        BET_YANKEE: 'ヤンキー',
        BONUS: '残高調整',
        CASINO: '移動',
        DEPOSIT: '入金',
        GAMES: 'スロット',
        MANUAL_ADJUSTMENT: '手動調整',
        PRIORITY_CARD_CASH: 'キャッシュ',
        PRIORITY_CARD_CASHBACK: 'キャッシュバックで入金',
        PRIORITY_CARD_DEPOSIT: '入金',
        PRIORITY_CARD_NON_CASH: '非キャッシュ',
        PRIORITY_CARD_OTHER: 'その他',
        PRIORITY_CARD_PURCHASE: '入金',
        PRIORITY_CARD_QUASI_CASH: 'Quasi-cash',
        PRIORITY_CARD_REFUND: 'Refund',
        PRIORITY_CARD_TRANSACTION: '支払い',
        REVERSAL: '出金リバース',
        SLOTS: 'スロット',
        TRANSFER: '移動',
        VEGAS: 'ベガス',
        WITHDRAWAL: '出金',
        POKER: 'ポーカー',
        BINGO: 'ビンゴ',
        LIVE_CASINO: 'ライブ・カジノ'
      },
      manualAdjustmentType: {
        AFFP: 'アフィリエイト支払い',
        AFFR: 'アフィリエイトレイクバック',
        BCNV: '残高変換',
        BETC: 'ベット修正',
        BNJW: 'ジャックポット勝利',
        BNKC: '銀行手数料',
        BONS: '手動ボーナス',
        BPCS: 'ボーナス支払い (cs)',
        BTCS: '残高移動 (cs)',
        CADJ: 'コミッション調整',
        CSH: 'キャッシュ調整',
        CWIN: '払戻し削減',
        GWCS: 'グッドウィルボーナス (cs)',
        GWIL: 'グッドウィルボーナス',
        HEDG: 'ヘッジ',
        INAC: '維持管理費用',
        ISCS: '不正確な決済',
        LFND: '資金調整',
        MCM: '手動キャッシュ移動',
        ONCR: '調整中',
        PGCW: 'コミッション調整',
        RCHQ: '小切手を返却',
        SCHQ: '小切手を中止',
        TFCS: '資金調整',
        WOFF: '相殺'
      },
      result: {
        WIN: '勝ち',
        LOST: '負け',
        VOIDED: '無効',
        CASHED_IN: 'キャッシュイン',
        STAKE: 'ステイク',
        CANCELED: 'キャンセル',
        PLACED: 'ベット'
      },
      paymentMethod: {
        APPLEPAY: 'Apple Pay',
        BANKTRANSFER: '銀行送金',
        CARD: 'クレジットカード/デビットカード',
        CHEQUE: '小切手',
        CLICK2PAY: 'Click2Pay',
        CLICKANDBUY: 'Click And Buy',
        DIRECTBANKTRANSFER: '直接送金',
        ECOPAYZ: 'EcoPayz',
        ENTROPAY: 'Entropay',
        ENVOY: 'Envoy',
        EPAYVOUCHER: 'ePay Voucher',
        NETELLER: 'Neteller',
        OTHER: 'その他',
        PAYPAL: 'Paypal',
        PAYSAFECARD: 'Paysafe Card',
        PINGIT: 'Pingit',
        PLUS: 'Plus Card',
        QUICKCASH: 'CashDirect',
        SKRILL: 'Skrill',
        UKASH: 'Ukash International',
        WESTERNUNION: 'Western Union',
        MUCHBETTER: 'MuchBetter'
      },
      sort: {
        ANYTIME_SCORECAST: 'いつでもスコアキャスト',
        ANYTIME_WINCAST: 'いつでもウィンキャスト',
        ASIAN_HANDICAP: 'アジアンハンディキャップ',
        BYO: 'Build #YourOdds',
        COMBINATION_FIRST_FOUR: 'コンビネーション ファーストフォー',
        COMBINATION_FORECAST: 'コンビネーション フォアキャスト',
        COMBINATION_QUINELLA: 'コンビネーション 馬連',
        COMBINATION_TRICAST: 'コンビネーション トライキャスト',
        CONTINUOUS_WIN: '連勝',
        FIRST_FOUR: 'ファーストフォー',
        FIRST_HALF_ASIAN_HANDICAP: '前半 アジアンハンディキャップ',
        FIRST_HALF_OUTRIGHT: '前半 アウトライト',
        FIRST_HALF_WESTERN_HANDICAP: '前半 ウエスタンハンディキャップ',
        FIRST_WINCAST: '最初のウィンキャスト',
        FORECAST: 'フォアキャスト',
        HIGHER_LOWER: '高い/低い',
        HIGHER_LOWER_SPLIT_OFFER: '高い/低い (スプリットオファーで)',
        INSURED_SCORECAST: 'スコアキャスト保証',
        INSURED_WINCAST: 'ウィンキャスト保証',
        LAST_SCORECAST: '最後のスコアキャスト',
        LAST_WINCAST: '最後のウィンキャスト',
        MATCH_HANDICAP: '試合ハンディキャップ',
        OVER_UNDER: 'オーバー/アンダー',
        PERMED_FORECAST: 'パームフォアキャスト',
        PERMED_TRICAST: 'パームトライキャスト',
        POINTS_MARKET: '得点マーケット',
        QUINELLA: '馬連',
        REVERSE_FORECAST: 'リバースフォアキャスト',
        SCORECAST: 'スコアキャスト保証',
        SECOND_HALF_ASIAN_HANDICAP: '後半 アジアンハンディキャップ',
        SECOND_HALF_OUTRIGHT: '後半 アウトライト',
        SECOND_HALF_WESTERN_HANDICAP: '後半 ウエスタンハンディキャップ',
        SIMPLE: 'シングル',
        STANDOUT_FIRST_FOUR: 'スタンドアウト ファーストフォー',
        STANDOUT_FORECAST: 'スタンドアウト フォアキャスト',
        STANDOUT_QUINELLA: 'スタンドアウト 馬連',
        STANDOUT_TRICAST: 'スタンドアウト トライキャスト',
        STRAIGHT_FORECAST: 'ストレート フォアキャスト',
        TRICAST: 'トライキャスト',
        TRICAST_OPTIONS: 'トライキャストオプション',
        WESTERN_HANDICAP: 'ウエスタン (ストレート) ハンディキャップ',
        XTH_SCORER_SCORECAST: 'X番目 得点者 スコアキャスト',
        XTH_SCORER_WINCAST: 'X番目 得点者 ウィンキャスト'
      },
      boostedBet: 'ベットブースト',
      loadMore: 'もっと読み込む',
      noTransactions: '取引がありません',
      resetFilters: {
        filtersApplied: 'フィルター適用',
        removeFilters: 'すべて削除'
      },
      summary: {
        correctAsOfMidnight: '深夜更新',
        lastRefresh: '{{day}} {{month}} {{year}}',
        profitLoss: '利益と損失',
        sports: 'スポーツベット',
        gaming: 'ゲーミング',
        profitLossBreakdown: '利益と損失の内訳',
        winsLosses: '勝ち - 負け',
        netDeposit: '純入金',
        lifetimeNetDeposit: '生涯純入金',
        totalDepositsWithdrawals: '出金総額 - 入金総額',
        netDepositAvailableFrom: '詳細は2008年6月12日からのみ入手可能です',
        saferGamblingNote: {
          title: '安全にギャンブルを行われていますか？',
          description: 'ギャンブルを楽しみながら、また余裕のある金額を使用されていることを再度ご確認ください。これについてサポートが必要と思われる場合は、{{link}}をご確認ください。',
          link: 'より安全なギャンブルの管理ツール'
        }
      }
    },
    filters: {
      dropdown: {
        transactionsSummary: {
          date: '今月現在まで',
          filters: 'フィルター適用'
        },
        transactionsHistory: {
          date: '過去7日',
          filters: 'フィルター適用'
        }
      },
      customDateRange: {
        toLabel: 'まで',
        labels: {
          from: 'から',
          to: 'まで'
        },
        error: '有効な日付範囲を選択するか、別の日付を選択してください。',
        historyLimitation: {
          caption: '1年以前のお取引につきましてはご確認いただけない場合がございます。それらを確認されたい場合は、カスタマーサポートまでご連絡ください。',
          link: '日本語カスタマーサポート'
        }
      },
      predefinedDateRange: {
        sectionName: '日付',
        allDates: 'すべての日付',
        last7: '過去7日',
        last14: '過去14日',
        last30: '過去30日',
        custom: 'カスタム'
      },
      transactionsSummaryDateRange: {
        sectionName: '日付を選択',
        monthToDate: '今月現在まで',
        last7days: '過去7日',
        last12months: '過去12か月'
      },
      view: {
        sectionName: '見る',
        all: 'すべて',
        onlyPayments: '決済のみ',
        excludePayments: '決済を除く',
        onlyWins: '勝ちベットのみ',
        onlyLosses: '負けベットのみ'
      },
      showHideBetTypes: {
        sectionName: 'ベットを表示/隠す',
        singles: 'シングル',
        multiples: 'マルチ'
      },
      tabs: {
        all: 'すべて',
        sports: 'スポーツ',
        gaming: 'ゲーミング'
      },
      applyFilters: '適用'
    },
    footer: {
      button: {
        logout: {
          text: 'ログアウト'
        }
      },
      link: {
        feedback: 'フィードバック',
        help: 'ヘルプ'
      }
    },
    oddsFormat: {
      title: 'オッズ形式',
      decimal: '少数',
      fractional: '分数'
    },
    personalDetails: {
      tabs: {
        contact: '問い合わせ',
        marketing: 'マーケティング'
      }
    },
    personalDetailsContact: {
      securityMessage: {
        title: 'William Hillではお客様のセキュリティとプライバシーを重要視しています。',
        text: 'お客様のお名前、ご住所、電話番号、メールアドレスなどの個人情報は安全な場所に保管されます。\
詳細を変更されたい場合は下記の項目に入力し、「詳細変更」をクリックしてください。\
変更後の詳細は当社システムで保管され、このページには表示されません。'
      },
      statusMessage: {
        success: '詳細が変更されました',
        failure: 'エラーが発生しました'
      },
      fields: {
        email: {
          label: 'メールアドレス'
        },
        addressLine1: {
          label: '住所 1'
        },
        addressLine2: {
          label: '住所 2'
        },
        addressCity: {
          label: '都道府県'
        },
        addressCounty: {
          label: '州/県/郡（任意）'
        },
        addressPostcode: {
          label: '郵便番号'
        },
        country: {
          label: '国',
          defaultValue: 'リストから選択してください'
        },
        mobile: {
          label: '携帯電話番号'
        }
      },
      buttons: {
        submit: '詳細を変更'
      },
      validationRules: {
        email: {
          required: 'メールアドレスは入力必須項目です',
          maxLength: '最大60文字で入力してください',
          email: '有効なメールアドレスを入力してください'
        },
        street1: {
          required: '住所は入力必須項目です',
          maxLength: '最大160文字で入力してください',
          pattern: '無効な文字です'
        },
        street2: {
          required: '住所は入力必須項目です',
          maxLength: '最大160文字で入力してください',
          pattern: '無効な文字です'
        },
        city: {
          required: '都道府県は入力必須項目です',
          pattern: '無効な文字です',
          maxLength: '最大60文字で入力してください'
        },
        county: {
          pattern: '無効な文字です',
          maxLength: '最大60文字で入力してください'
        },
        postcode: {
          required: '郵便番号は入力必須項目です',
          pattern: '無効な文字です',
          maxLength: '最大12文字で入力してください'
        },
        mobile: {
          required: '電話番号は入力必須項目です',
          pattern: '無効な文字です。数字のみ使用可能です。',
          minLength: '6文字以上で入力してください',
          maxLength: '最大20文字で入力してください'
        }
      }
    },
    personalDetailsTimezone: {
      statusMessage: {
        success: 'タイムゾーンが更新されました',
        failure: 'エラーが発生しました'
      },
      buttons: {
        updateTimezone: 'タイムゾーンを更新'
      },
      fields: {
        timezones: {
          label: 'タイムゾーン',
          values: {
            TIMEZONE_AFRICA_ADDIS_ABABA: 'アフリカ/アディスアベバ',
            TIMEZONE_AFRICA_JOHANNESBURG: 'アフリカ/ヨハネスブルグ',
            TIMEZONE_AMERICA_ANCHORAGE: 'アメリカ/アンカレッジ',
            TIMEZONE_AMERICA_ARGENTINA_BUENOS_AIRES: 'アメリカ/アルゼンチン/ブエノスアイレス',
            TIMEZONE_AMERICA_CHICAGO: 'アメリカ/シカゴ',
            TIMEZONE_AMERICA_DENVER: 'アメリカ/デンバー',
            TIMEZONE_AMERICA_LOS_ANGELES: 'アメリカ/ロサンゼルス',
            TIMEZONE_AMERICA_NEW_YORK: 'アメリカ/ニューヨーク',
            TIMEZONE_AMERICA_SAO_PAULO: 'アメリカ/サンパウロ',
            TIMEZONE_AMERICA_TORONTO: 'アメリカ/トロント',
            TIMEZONE_AMERICA_VANCOUVER: 'アメリカ/バンクーバー',
            TIMEZONE_ASIA_BANGKOK: 'アジア/ダッカ',
            TIMEZONE_ASIA_DHAKA: 'アジア/ドバイ',
            TIMEZONE_ASIA_DUBAI: 'アジア/香港',
            TIMEZONE_ASIA_HONG_KONG: 'アジア/香港',
            TIMEZONE_ASIA_JERUSALEM: 'アジア/エルサレム',
            TIMEZONE_ASIA_KARACHI: 'アジア/カラチ',
            TIMEZONE_ASIA_KOLKATA: 'アジア/コルカタ',
            TIMEZONE_ASIA_RANGOON: 'アジア/ヤンゴン',
            TIMEZONE_ASIA_SINGAPORE: 'アジア/シンガポール',
            TIMEZONE_ASIA_TOKYO: 'アジア/東京',
            TIMEZONE_ATLANTIC_AZORES: '大西洋/アゾレス',
            TIMEZONE_ATLANTIC_BERMUDA: '大西洋/バミューダ',
            TIMEZONE_AUSTRALIA_ADELAIDE: 'オーストラリア/アデレード',
            TIMEZONE_AUSTRALIA_PERTH: 'オーストラリア/パース',
            TIMEZONE_AUSTRALIA_SYDNEY: 'オーストラリア/シドニー',
            TIMEZONE_EUROPE_ATHENS: 'ヨーロッパ/アテネ',
            TIMEZONE_EUROPE_BERLIN: 'ヨーロッパ/ベルリン',
            TIMEZONE_EUROPE_DUBLIN: 'ヨーロッパ/ダブリン',
            TIMEZONE_EUROPE_GIBRALTAR: 'ヨーロッパ/ジブラルタル',
            TIMEZONE_EUROPE_KIEV: 'ヨーロッパ/キエフ',
            TIMEZONE_EUROPE_LONDON: 'ヨーロッパ/ロンドン',
            TIMEZONE_EUROPE_MADRID: 'ヨーロッパ/マドリード',
            TIMEZONE_EUROPE_MOSCOW: 'ヨーロッパ/モスクワ',
            TIMEZONE_EUROPE_PARIS: 'ヨーロッパ/パリ',
            TIMEZONE_EUROPE_ROME: 'ヨーロッパ/ローマ',
            TIMEZONE_EUROPE_SOFIA: 'ヨーロッパ/ソフィア',
            TIMEZONE_EUROPE_VIENNA: 'ヨーロッパ/ウィーン',
            TIMEZONE_EUROPE_WARSAW: 'ヨーロッパ/ワルシャワ',
            TIMEZONE_INDIAN_CHRISTMAS: 'インド洋/クリスマス島',
            TIMEZONE_PACIFIC_AUCKLAND: '太平洋/オークランド',
            TIMEZONE_PACIFIC_GUADALCANAL: '太平洋/ガダルカナル島',
            TIMEZONE_PACIFIC_HONOLULU: '太平洋/ホノルル',
            TIMEZONE_PACIFIC_MIDWAY: '太平洋/ミッドウェー島'
          }
        }
      },
      validationRules: {
        required: 'タイムゾーンを選択する'
      }
    },
    personalDetailsMarketing: {
      mainNote: 'メールまたは電話によるボーナス、オファー、最新情報などのニュース受信を希望します。設定はいつでも変更可能です。',
      contactMethodLabel: {
        telephone: '電話',
        email: 'メール',
        sms: 'SMS'
      },
      error: {
        save: '恐れ入りますが現在データが保存できません。再度お試しください。'
      },
      disclaimer: {
        text: '免責事項：',
        note: '変更が適用されるまで最大48時間かかる場合があります。\
当社サービスとしてプッシュ通知を使用します。なおお使いのデバイスより通知設定にて設定の変更が可能です。\
複数のデバイスをご利用の場合、\
それぞれのデバイスにて設定を変更してください。'
      }
    },
    loginSecurity: {
      changePassword: 'パスワード変更',
      currentPassword: '現在のパスワード',
      newPassword: '新しいパスワード',
      savePassword: '新しいパスワードを保存',
      passwordUpdated: 'パスワードが変更されました',
      genericErrorMessage: 'エラーが発生しました',
      validationRules: {
        currentPassword: {
          required: '現在のパスワード欄が空白です',
          invalidCredentials: 'パスワードに誤りがあります'
        },
        newPassword: {
          required: '新しいパスワード欄が空白です',
          minLength: '新しいパスワードが8文字未満または15文字を超えています',
          maxLength: '新しいパスワードが8文字未満または15文字を超えています',
          hasDigit: '新しいパスワードに数字、小文字、また大文字が含まれていません',
          hasUppercaseLetter: '新しいパスワードに数字、小文字、また大文字が含まれていません',
          pattern: '新しいパスワードは8文字以上で、少なくとも1つの文字、数字、記号を含める必要があります (!#%&()*+,-./:<=>?@^_`|~)。',
          cannotBeEqualToLastPassword: '以前使用されたパスワードは新しいパスワードに使用できません'
        },
        genericRules: '8〜15文字を使用してください。少なくとも1つの文字、数字、記号を含める必要があります (!#%&()*+,./:<=>?@^_`|~)。大文字と小文字は区別されます。スペースは使用できません。'
      }
    },
    accountNetDeposit: {
      title: '生涯アカウント入金総額',
      description: '入金総額はお客様のアカウントで行われたすべての取引の合計です (入金額から出金額を差し引いたもの)。',
      accessNote: '当社で確認できるお客様のアカウント詳細は2008年12月6日以降のものとなります。',
      timePeriod: {
        title: '期間内の入金総額',
        description: '選択された期間内の入金総額で、この詳細は登録されたメールアドレスに24時間以内に送信されます。',
        optionsTitle: '期間を選択する',
        optionLabels: {
          LAST_DAY: '前日',
          LAST_WEEK: '過去7日間',
          LAST_MONTH: '過去30日間'
        },
        success: 'この詳細は登録されたメールアドレスに24時間以内に送信されます。',
        requestDeposit: '期間内の入金総額をメール送信する'
      },
      lifetimeNetDepositButton: '生涯アカウント入金総額を見る'
    },
    error: {
      network: {
        text: 'ネットワークエラーが発生しました。',
        subText: 'しばらく経ってから再度お試しください。',
        retrySubText: 'しばらく経ってからマイアカウントにアクセスしてください。'
      },
      graphQL: {
        text: 'データを取得できませんでした',
        subText: 'しばらく経ってから再度お試しください。',
        retrySubText: 'しばらく経ってからマイアカウントにアクセスしてください。'
      },
      retry: '再試行',
      iconAlt: 'Traffic Cone'
    },
    confirmationModal: {
      confirmationText: 'はい',
      cancellationText: '番号'
    }
  },
  countries: {
    COUNTRY_AD: 'アンドラ',
    COUNTRY_AE: 'アラブ首長国連邦',
    COUNTRY_AF: 'アフガニスタン',
    COUNTRY_AG: 'アンティグア・バーブーダ',
    COUNTRY_AI: 'アンギラ',
    COUNTRY_AL: 'アルバニア',
    COUNTRY_AM: 'アルメニア',
    COUNTRY_AN: 'オランダ領アンティル',
    COUNTRY_AO: 'アンゴラ',
    COUNTRY_AQ: '南極大陸',
    COUNTRY_AR: 'アルゼンチン',
    COUNTRY_AS: 'アメリカ領サモア',
    COUNTRY_AT: 'オーストリア',
    COUNTRY_AU: 'オーストラリア',
    COUNTRY_AW: 'アルバ',
    COUNTRY_AX: 'オーランド諸島',
    COUNTRY_AZ: 'アゼルバイジャン',
    COUNTRY_BA: 'ボスニア・ヘルツェゴビナ',
    COUNTRY_BB: 'バルバドス',
    COUNTRY_BC: 'ブリティッシュコロンビア',
    COUNTRY_BD: 'バングラデシュ',
    COUNTRY_BE: 'ベルギー',
    COUNTRY_BF: 'ブルキナファソ',
    COUNTRY_BG: 'ブルガリア',
    COUNTRY_BH: 'バーレーン',
    COUNTRY_BI: 'ブルンジ',
    COUNTRY_BJ: 'ベナン',
    COUNTRY_BM: 'バミューダ諸島',
    COUNTRY_BN: 'ブルネイ',
    COUNTRY_BO: 'ボリビア',
    COUNTRY_BR: 'ブラジル',
    COUNTRY_BS: 'バハマ',
    COUNTRY_BT: 'ブータン',
    COUNTRY_BV: 'ブーベ島',
    COUNTRY_BW: 'ボツワナ',
    COUNTRY_BY: 'ベラルーシ',
    COUNTRY_BZ: 'ベリーズ',
    COUNTRY_CA: 'カナダ',
    COUNTRY_CC: 'ココス（キーリング）諸島',
    COUNTRY_CD: 'コンゴ共和国',
    COUNTRY_CF: '中央アフリカ共和国',
    COUNTRY_CG: 'コンゴ民主共和国',
    COUNTRY_CH: 'スイス',
    COUNTRY_CI: 'コートジボワール',
    COUNTRY_CK: 'クック諸島',
    COUNTRY_CL: 'チリ',
    COUNTRY_CM: 'カメルーン',
    COUNTRY_CN: '中華人民共和国',
    COUNTRY_CO: 'コロンビア',
    COUNTRY_CR: 'コスタリカ',
    COUNTRY_CU: 'キューバ',
    COUNTRY_CV: 'カーボベルデ',
    COUNTRY_CX: 'クリスマス島',
    COUNTRY_CY: 'キプロス',
    COUNTRY_CZ: 'チェコ',
    COUNTRY_DE: 'ドイツ',
    COUNTRY_DJ: 'ジブチ',
    COUNTRY_DK: 'デンマーク',
    COUNTRY_DM: 'ドミニカ',
    COUNTRY_DO: 'ドミニカ共和国',
    COUNTRY_DZ: 'アルジェリア',
    COUNTRY_EC: 'エクアドル',
    COUNTRY_EE: 'エストニア',
    COUNTRY_EG: 'エジプト',
    COUNTRY_EH: '西サハラ',
    COUNTRY_ER: 'エリトリア',
    COUNTRY_ES: 'スペイン',
    COUNTRY_ET: 'エチオピア',
    COUNTRY_EU: '欧州連合',
    COUNTRY_FI: 'フィンランド',
    COUNTRY_FJ: 'フィジー',
    COUNTRY_FK: 'フォークランド諸島',
    COUNTRY_FM: 'ミクロネシア',
    COUNTRY_FO: 'フェロー諸島',
    COUNTRY_FR: 'フランス',
    COUNTRY_FX: 'フランス・メトロポリテーヌ',
    COUNTRY_GA: 'ガボン',
    COUNTRY_GD: 'グレナダ',
    COUNTRY_GE: 'ジョージア',
    COUNTRY_GF: 'フランス領ギアナ',
    COUNTRY_GG: 'ガーンジー島',
    COUNTRY_GH: 'ガーナ',
    COUNTRY_GI: 'ジブラルタル',
    COUNTRY_GL: 'グリーンランド',
    COUNTRY_GM: 'ガンビア',
    COUNTRY_GN: 'ギニア',
    COUNTRY_GP: 'グアドループ',
    COUNTRY_GQ: '赤道ギニア共和国',
    COUNTRY_GR: 'ギリシャ',
    COUNTRY_GS: 'サウスジョージア',
    COUNTRY_GT: 'グアテマラ',
    COUNTRY_GU: 'グアム',
    COUNTRY_GW: 'ギニアビサウ',
    COUNTRY_GY: 'ガイアナ',
    COUNTRY_HK: '香港',
    COUNTRY_HM: 'ハード島とマクドナルド諸島',
    COUNTRY_HN: 'ホンジュラス',
    COUNTRY_HR: 'クロアチア',
    COUNTRY_HT: 'ハイチ',
    COUNTRY_HU: 'ハンガリー',
    COUNTRY_ID: 'インドネシア',
    COUNTRY_IE: 'アイルランド',
    COUNTRY_IL: 'イスラエル',
    COUNTRY_IM: 'マン島',
    COUNTRY_IN: 'インド',
    COUNTRY_IO: 'イギリス領インド洋地域',
    COUNTRY_IQ: 'イラク',
    COUNTRY_IR: 'イラン',
    COUNTRY_IS: 'アイスランド',
    COUNTRY_IT: 'イタリア',
    COUNTRY_JE: 'ジャージー',
    COUNTRY_JM: 'ジャマイカ',
    COUNTRY_JO: 'ヨルダン',
    COUNTRY_JP: '日本',
    COUNTRY_KE: 'ケニア',
    COUNTRY_KG: 'キルギス',
    COUNTRY_KH: 'カンボジア',
    COUNTRY_KI: 'キリバス',
    COUNTRY_KM: 'コモロ',
    COUNTRY_KN: 'セントクリストファー・ネイビス',
    COUNTRY_KP: '北朝鮮',
    COUNTRY_KR: '韓国',
    COUNTRY_KW: 'クウェート',
    COUNTRY_KY: 'ケイマン諸島',
    COUNTRY_KZ: 'カザフスタン',
    COUNTRY_LA: 'ラオス',
    COUNTRY_LB: 'レバノン',
    COUNTRY_LC: 'セントルシア',
    COUNTRY_LI: 'リヒテンシュタイン',
    COUNTRY_LK: 'スリランカ',
    COUNTRY_LR: 'リベリア',
    COUNTRY_LS: 'レソト',
    COUNTRY_LT: 'リトアニア',
    COUNTRY_LU: 'ルクセンブルク',
    COUNTRY_LV: 'ラトビア',
    COUNTRY_LY: 'リビア',
    COUNTRY_MA: 'モロッコ',
    COUNTRY_MC: 'モナコ',
    COUNTRY_MD: 'モルドバ',
    COUNTRY_ME: 'モンテネグロ',
    COUNTRY_MG: 'マダガスカル',
    COUNTRY_MH: 'マーシャル諸島',
    COUNTRY_MK: 'F.Y. マケドニア共和国',
    COUNTRY_ML: 'マリ',
    COUNTRY_MM: 'ミャンマー',
    COUNTRY_MN: 'モンゴル',
    COUNTRY_MO: 'マカオ',
    COUNTRY_MP: '北マリアナ諸島',
    COUNTRY_MQ: 'マルティニーク',
    COUNTRY_MR: 'モーリタニア',
    COUNTRY_MS: 'モントセラト',
    COUNTRY_MT: 'マルタ',
    COUNTRY_MU: 'モーリシャス',
    COUNTRY_MV: 'モルディブ',
    COUNTRY_MW: 'マラウイ',
    COUNTRY_MX: 'メキシコ',
    COUNTRY_MY: 'マレーシア',
    COUNTRY_MZ: 'モザンビーク',
    COUNTRY_NA: 'ナミビア',
    COUNTRY_NC: 'ニューカレドニア',
    COUNTRY_NE: 'ニジェール',
    COUNTRY_NF: 'ノーフォーク島',
    COUNTRY_NG: 'ナイジェリア',
    COUNTRY_NI: 'ニカラグア',
    COUNTRY_NL: 'オランダ',
    COUNTRY_NO: 'ノルウェー',
    COUNTRY_NP: 'ネパール',
    COUNTRY_NR: 'ナウル',
    COUNTRY_NU: 'ニウエ',
    COUNTRY_NZ: 'ニュージーランド',
    COUNTRY_OM: 'オマーン',
    COUNTRY_PA: 'パナマ',
    COUNTRY_PE: 'ペルー',
    COUNTRY_PF: 'フランス領ポリネシア',
    COUNTRY_PG: 'パプアニューギニア',
    COUNTRY_PH: 'フィリピン',
    COUNTRY_PK: 'パキスタン',
    COUNTRY_PL: 'ポーランド',
    COUNTRY_PM: 'サンピエール島・ミクロン島',
    COUNTRY_PN: 'ピトケアン諸島',
    COUNTRY_PR: 'プエルトリコ',
    COUNTRY_PS: 'パレスチナ自治区',
    COUNTRY_PT: 'ポルトガル',
    COUNTRY_PW: 'パラオ',
    COUNTRY_PY: 'パラグアイ',
    COUNTRY_QA: 'カタール',
    COUNTRY_RE: 'レユニオン',
    COUNTRY_RO: 'ルーマニア',
    COUNTRY_RS: 'セルビア',
    COUNTRY_RU: 'ロシア',
    COUNTRY_RW: 'ルワンダ',
    COUNTRY_SA: 'サウジアラビア',
    COUNTRY_SB: 'ソロモン諸島',
    COUNTRY_SC: 'セーシェル',
    COUNTRY_SD: 'スーダン',
    COUNTRY_SE: 'スウェーデン',
    COUNTRY_SG: 'シンガポール',
    COUNTRY_SH: 'セントヘレナ',
    COUNTRY_SI: 'スロベニア',
    COUNTRY_SJ: 'スヴァールバル諸島およびヤンマイエン島',
    COUNTRY_SK: 'スロバキア',
    COUNTRY_SL: 'シエラレオネ',
    COUNTRY_SM: 'サンマリノ',
    COUNTRY_SN: 'セネガル',
    COUNTRY_SO: 'ソマリア',
    COUNTRY_SR: 'スリナム',
    COUNTRY_ST: 'サントメ・プリンシペ',
    COUNTRY_SV: 'エルサルバドル',
    COUNTRY_SY: 'シリア',
    COUNTRY_SZ: 'スワジランド',
    COUNTRY_TA: 'トリスタンダクーニャ',
    COUNTRY_TC: 'タークス・カイコス諸島',
    COUNTRY_TD: 'チャド',
    COUNTRY_TF: 'フランス領南方地域',
    COUNTRY_TG: 'トーゴ',
    COUNTRY_TH: 'タイ王国',
    COUNTRY_TJ: 'タジキスタン',
    COUNTRY_TK: 'トケラウ',
    COUNTRY_TM: 'トルクメニスタン',
    COUNTRY_TN: 'チュニジア',
    COUNTRY_TO: 'トンガ',
    COUNTRY_TP: '東ティモール',
    COUNTRY_TR: 'トルコ',
    COUNTRY_TT: 'トリニダード・ドバゴ',
    COUNTRY_TV: 'ツバル',
    COUNTRY_TW: '台湾',
    COUNTRY_TZ: 'タンザニア',
    COUNTRY_UA: 'ウクライナ',
    COUNTRY_UG: 'ウガンダ',
    COUNTRY_UK: 'イギリス',
    COUNTRY_UM: '合衆国領有小離島',
    COUNTRY_US: 'アメリカ合衆国',
    COUNTRY_UY: 'ウルグアイ',
    COUNTRY_UZ: 'ウズベキスタン',
    COUNTRY_VA: 'バチカン市国',
    COUNTRY_VC: 'セントビンセントおよびグレナディーン諸島',
    COUNTRY_VE: 'ベネズエラ',
    COUNTRY_VG: 'イギリス領ヴァージン諸島',
    COUNTRY_VI: 'ヴァージン諸島（アメリカ合衆国）',
    COUNTRY_VN: 'ベトナム',
    COUNTRY_VU: 'バヌアツ',
    COUNTRY_WE: '西サモア',
    COUNTRY_WF: 'ウォリス・フツナ',
    COUNTRY_WS: 'サモア',
    COUNTRY_YE: 'イエメン',
    COUNTRY_YT: 'マヨット',
    COUNTRY_ZA: '南アフリカ',
    COUNTRY_ZM: 'ザンビア',
    COUNTRY_ZW: 'ジンバブエ'
  },
  'ui-kit': uiKit,
  date: {
    today: '本日',
    months: {
      JAN: uiKit.datepicker.january,
      FEB: uiKit.datepicker.february,
      MAR: uiKit.datepicker.march,
      APR: uiKit.datepicker.april,
      MAY: uiKit.datepicker.may,
      JUN: uiKit.datepicker.june,
      JUL: uiKit.datepicker.july,
      AUG: uiKit.datepicker.august,
      SEP: uiKit.datepicker.september,
      OCT: uiKit.datepicker.october,
      NOV: uiKit.datepicker.november,
      DEC: uiKit.datepicker.december
    },
    monthsNumbered: {
      '01': uiKit.datepicker.january,
      '02': uiKit.datepicker.february,
      '03': uiKit.datepicker.march,
      '04': uiKit.datepicker.april,
      '05': uiKit.datepicker.may,
      '06': uiKit.datepicker.june,
      '07': uiKit.datepicker.july,
      '08': uiKit.datepicker.august,
      '09': uiKit.datepicker.september,
      10: uiKit.datepicker.october,
      11: uiKit.datepicker.november,
      12: uiKit.datepicker.december
    }
  }
};